"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlCheckbox = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _bero = _interopRequireWildcard(require("bero"));
var _componentIcon = require("@adl/component-icon");
var _componentUtils = require("@adl/component-utils");
var _componentFormNotice = require("@adl/component-form-notice");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "error", "errorText", "hintText", "htmlAttrs", "id", "inline", "input", "label", "name", "required", "success", "title", "tooltip", "value"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var bemCheckbox = (0, _bero.default)('gl-checkbox');
var FormWrap = function FormWrap(_ref) {
  var condition = _ref.condition,
    children = _ref.children;
  return condition ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "gl-form__element gl-form__element--checkbox",
    children: children
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: children
  });
};
var GlCheckbox = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(GlCheckbox, _PureComponent);
  var _super = _createSuper(GlCheckbox);
  function GlCheckbox(props) {
    var _this;
    (0, _classCallCheck2.default)(this, GlCheckbox);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleChange", function (event) {
      _this.setState({
        isChecked: event.target.checked
      });
      (0, _componentUtils.safeInvoke)(_this.props.onChange, event);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFocus", function () {
      if (!_this.state.isMouseDown) {
        _this.setState({
          hasFocus: true
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBlur", function () {
      _this.setState({
        hasFocus: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMouseDown", function () {
      _this.setState({
        isMouseDown: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMouseUp", function () {
      setTimeout(function () {
        _this.setState({
          isMouseDown: false
        });
      }, 200);
    });
    _this.state = {
      isChecked: Boolean(props.isChecked),
      hasFocus: false,
      isMouseDown: false
    };
    return _this;
  }
  (0, _createClass2.default)(GlCheckbox, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isChecked !== this.props.isChecked) {
        this.setState({
          isChecked: Boolean(this.props.isChecked)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        error = _this$props.error,
        errorText = _this$props.errorText,
        hintText = _this$props.hintText,
        htmlAttrs = _this$props.htmlAttrs,
        id = _this$props.id,
        _this$props$inline = _this$props.inline,
        inline = _this$props$inline === void 0 ? false : _this$props$inline,
        input = _this$props.input,
        label = _this$props.label,
        name = _this$props.name,
        required = _this$props.required,
        success = _this$props.success,
        title = _this$props.title,
        _this$props$tooltip = _this$props.tooltip,
        tooltip = _this$props$tooltip === void 0 ? null : _this$props$tooltip,
        value = _this$props.value,
        props = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var _this$state = this.state,
        checked = _this$state.isChecked,
        hasFocus = _this$state.hasFocus;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(FormWrap, {
        condition: Boolean(tooltip),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: (0, _bero.default)('gl-form-item', {
            inline: inline || tooltip,
            error: error,
            hasFocus: hasFocus,
            required: required,
            success: success
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
            className: (0, _bero.join)(bemCheckbox({
              checked: checked
            }), className)
          }, (0, _componentUtils.custom)(props)), {}, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("label", _objectSpread(_objectSpread({
              htmlFor: id,
              className: bemCheckbox('label')
            }, htmlAttrs === null || htmlAttrs === void 0 ? void 0 : htmlAttrs.label), {}, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread(_objectSpread({
                type: "checkbox",
                name: name,
                value: value,
                id: id,
                title: title,
                "aria-label": title,
                className: bemCheckbox('input'),
                checked: checked,
                onChange: this.toggleChange,
                onFocus: this.onFocus,
                onBlur: this.onBlur,
                onMouseDown: this.handleMouseDown,
                onMouseUp: this.handleMouseUp,
                required: required
              }, input), htmlAttrs === null || htmlAttrs === void 0 ? void 0 : htmlAttrs.input)), /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentIcon.GlIcon, {
                name: "checkbox-checkmark",
                iconClassName: bemCheckbox('icon'),
                "aria-hidden": "true"
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                className: bemCheckbox('text'),
                children: [label, required && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "gl-form-asterisk",
                  children: '*'
                })]
              })]
            })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentFormNotice.GlFormNotice, {
              className: bemCheckbox(),
              error: Boolean(error && errorText && !checked),
              errorText: errorText,
              errorAttrs: htmlAttrs === null || htmlAttrs === void 0 ? void 0 : htmlAttrs.error,
              hintText: hintText,
              hintAttrs: htmlAttrs === null || htmlAttrs === void 0 ? void 0 : htmlAttrs.hint
            })]
          }))
        }), tooltip]
      });
    }
  }]);
  return GlCheckbox;
}(_react.PureComponent);
exports.GlCheckbox = GlCheckbox;
(0, _defineProperty2.default)(GlCheckbox, "defaultProps", {
  isChecked: false,
  hasFocus: false,
  onChange: function onChange() {}
});